import { render, staticRenderFns } from "./IntegrationPhoneNumberForm.vue?vue&type=template&id=0421fa75&"
import script from "./IntegrationPhoneNumberForm.vue?vue&type=script&lang=js&"
export * from "./IntegrationPhoneNumberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports